import { Outlet } from "react-router-dom";
import { Sidebar } from "./Sidebar";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import { LanguageSwitcher } from "../general/LanguageSwitcher";
import { InboxProvider } from "../../context/InboxContext";

export const AdminLayout = () => {
  const { i18n } = useTranslation();
  const [collapsed, setCollapsed] = useState(false);
  const isRTL = i18n.dir() === "rtl";
  const width = collapsed
    ? "--sidebar-width-collapsed"
    : "--sidebar-width-expanded";
  return (
    <InboxProvider>
      <div style={{ display: "flex", minHeight: "100vh" }}>
        <Sidebar collapsed={collapsed} setCollapsed={setCollapsed} />
        <main
          style={{
            flexGrow: 1,
            padding: "20px",
            ...(isRTL
              ? { marginRight: `var(${width})` }
              : { marginLeft: `var(${width})` }),
          }}
        >
          <div className="d-grid w-100" style={{ justifyItems: "end" }}>
            <LanguageSwitcher />
          </div>

          <Outlet />
        </main>
      </div>
    </InboxProvider>
  );
};
